export const Url_Friendly_String = (value: string) => {
  return value
    .replace(/[^a-zA-Z0-9_-]/g, '-') // Replace non-alphanumeric with dash
    .replace(/-+/g, '-') // Replace multiple consecutive dashes with single dash
    .replace(/^-|-$/g, '');
};
